import React from 'react';

export default function FilterIcon({ path }) {
	return (		
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="filter-icon">
			<path d={path}></path>
		</svg>
	);
}